import React, { useState, useEffect, useRef } from "react";
import "react-quill/dist/quill.snow.css"; // Import styles for the rich text editor
import { AES, enc } from "crypto-js";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { BASE_URL } from "../CommonApi";
import Select, { components } from "../../../Components/forms/SearchableDropdown";
import ReactToPrint from "react-to-print";
import DatePicker from "react-datepicker"; // Import DatePicker for manual date selection
import "react-datepicker/dist/react-datepicker.css"; // Import DatePicker styles

function ProfitAndLossShedual3({ navigation }) {
  const lineStyle = {
    margin: "5px 0", // Add some margin between the lines
    border: "none",
    borderBottom: "2px solid #ccc", // Style the horizontal line
    width: "100%", // Set the width of the horizontal line
  };

  const blueTextStyle = {
    color: "blue",
  };
  const noteStyle = {
    textAlign: "right",
    color: "blue",
  };
  const handleNavigation = (key) => {
    if (navigation.state.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };
  const cancle = () => {
    const confirmCancel = window.confirm("Are you sure Leave this page?");
    if (confirmCancel) {
      // Code to handle cancellation
      handleNavigation("reports");
    } else {
      // Code to handle cancellation not confirmed
      console.log("Cancellation not confirmed");
    }
  };

  const [profitLoss, SetProfitLoss] = useState([]);
  const jwtToken = localStorage.getItem("jwtToken");
  const [loading, setLoading] = useState(true);
  const componentRef = useRef();

  useEffect(() => {
    // Get the encrypted uniqueId from session storage
    const encryptedUniqueId = localStorage.getItem("uniqueId1");

    // Decrypt the uniqueId using your decryption method
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    // Fetch invoices for the decrypted uniqueId
    fetch(BASE_URL + `/fetchProfitAndLoss`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }), // Send uniqueId in the request body
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          SetProfitLoss(data.responseMessage);
          setLoading(false);
        } else {
          console.error("Failed to fetch invoices:", data.responseMessage);
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
        setLoading(false);
      });
  }, []);

  const options = [
    { value: "today", label: "Today" },
    { value: "this_week", label: "This week" },
    { value: "this_month", label: "This month" },
    { value: "this_year", label: "This year" },
    { value: "this_quarter", label: "This Quarter" },
    { value: "yesterday", label: "Yesterday" },
    { value: "previous_week", label: "Previous Week" },
    { value: "previous_month", label: "Previous Month" },
    { value: "previous_quarter", label: "Previous Quarter" },
    { value: "previous_year", label: "Previous Year" },
    { value: "custom", label: "Custom" },
  ];

  const formatDate1 = (date) => {
    return date.toLocaleDateString("en-GB").replace(/\//g, "-"); // DD-MM-YYYY format
  };
  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  useEffect(() => {
    if (selectedOption) {
      const today = new Date();
      switch (selectedOption.value) {
        case "today":
          setFromDate(today);
          setToDate(today);
          break;
        case "yesterday":
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          setFromDate(yesterday);
          setToDate(yesterday);
          break;
        case "this_week":
          const sunday = new Date(today);
          sunday.setDate(today.getDate() - today.getDay());
          const saturday = new Date(today);
          saturday.setDate(today.getDate() + (6 - today.getDay()));
          setFromDate(sunday);
          setToDate(saturday);
          break;
        case "previous_week":
          const prevSunday = new Date(today);
          prevSunday.setDate(today.getDate() - today.getDay() - 7);
          const prevSaturday = new Date(today);
          prevSaturday.setDate(today.getDate() - today.getDay() - 1);
          setFromDate(prevSunday);
          setToDate(prevSaturday);
          break;
        case "this_month":
          const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
          );
          const lastDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth() + 1,
            0
          );
          setFromDate(firstDayOfMonth);
          setToDate(lastDayOfMonth);
          break;
        case "previous_month":
          const prevMonthStart = new Date(
            today.getFullYear(),
            today.getMonth() - 1,
            1
          );
          const prevMonthEnd = new Date(
            today.getFullYear(),
            today.getMonth(),
            0
          );
          setFromDate(prevMonthStart);
          setToDate(prevMonthEnd);
          break;
        case "this_quarter":
          const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
          const quarterStartDate = new Date(
            today.getFullYear(),
            quarterStartMonth,
            1
          );
          const quarterEndDate = new Date(
            today.getFullYear(),
            quarterStartMonth + 3,
            0
          );
          setFromDate(quarterStartDate);
          setToDate(quarterEndDate);
          break;
        case "previous_quarter":
          const prevQuarterStartMonth =
            Math.floor((today.getMonth() - 3) / 3) * 3;
          const prevQuarterStartDate = new Date(
            today.getFullYear(),
            prevQuarterStartMonth,
            1
          );
          const prevQuarterEndDate = new Date(
            today.getFullYear(),
            prevQuarterStartMonth + 3,
            0
          );
          setFromDate(prevQuarterStartDate);
          setToDate(prevQuarterEndDate);
          break;
        case "this_year":
          const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
          const lastDayOfYear = new Date(today.getFullYear(), 11, 31);
          setFromDate(firstDayOfYear);
          setToDate(lastDayOfYear);
          break;
        case "previous_year":
          const prevYearStart = new Date(today.getFullYear() - 1, 0, 1);
          const prevYearEnd = new Date(today.getFullYear() - 1, 11, 31);
          setFromDate(prevYearStart);
          setToDate(prevYearEnd);
          break;
        case "custom":
          setFromDate(today);
          setToDate(today);
          break;
        default:
          setFromDate(null);
          setToDate(null);
          break;
      }
    }
  }, [selectedOption]); // This effect runs when selectedOption state changes

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="page-content">
          <div class="center-div">
            <div class="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      border: "1px solid #ccc",
      borderRadius: "4px",
      paddingLeft: "6px",
      width: "100%",
      maxWidth: "400px", // Ensure responsiveness
      boxSizing: "border-box",
    }),
    menu: (provided) => ({
      ...provided,
      width: "100%",
      maxWidth: "400px",
    }),
  };

  const CustomControl = ({ children, ...props }) => (
    <components.Control {...props}>
      <span className="custom-control-icon">📅</span>
      {children}
    </components.Control>
  );

  return (
    <>
      <style>
        {`
          .custom-datepicker-wrapper {
            position: relative;
            display: inline-block;
            width: 200px;
          }

          .custom-datepicker-calendar {
            border: 1px solid #ccc;
            border-radius: 4px;
          }

          .react-datepicker__input-container {
            width: 100%;
          }

          .react-datepicker__input-container input {
            width: 100%;
            height: 40px;
            padding: 0 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            font-size: 16px;
          }

          .custom-label {
            display: block;
            margin-bottom: 5px;
            font-size: 16px;
            color: #333;
          }

          .custom-date-picker {
            display: flex;
            align-items: center;
            margin-right: 10px;
          }
        `}
      </style>

      <div className="d-flex align-items-center ml-1 mt-4">
        <div
          className="cursor-pointer d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "white",
            borderRadius: "50%",
            height: "35px",
            width: "38px",
            cursor: "pointer",
          }}
        >
          <ArrowBackIosIcon
            width={2}
            onClick={cancle}
            className="arrow-child"
          />
        </div>
        <div className="headitems ml-2">
          <h5
            className="ml-1 mb-0"
            style={{ letterSpacing: "1px", color: "#086bd5de" }}
          >
            Profit and Loss (Schedule III)
          </h5>
        </div>
      </div>
      <div className="horizontal-section my-3 mx-0">
        <div className="d-flex justify-content-between mt-1 mb-1 ml-3">
          <div className="d-flex align-items-center">
            <Select
              value={selectedOption}
              onChange={handleOptionChange}
              options={options}
              styles={customStyles}
              components={{ Control: CustomControl }}
            />
          </div>
          {selectedOption.value === "custom" && (
            <div className="d-flex align-items-center ml-auto">
              <div className="custom-date-picker">
                <label htmlFor="from-date" className="custom-label mr-2">
                  From Date:
                </label>{" "}
                <DatePicker
                  id="from-date"
                  selected={fromDate}
                  onChange={(date) => setFromDate(date)}
                  dateFormat="dd/MM/yyyy"
                  wrapperClassName="custom-datepicker-wrapper"
                  calendarClassName="custom-datepicker-calendar"
                  style={{ backgroundColor: "white" }}
                />
              </div>
              <div className="custom-date-picker">
                <label htmlFor="to-date" className="custom-label mr-2">
                  To Date:
                </label>
                <DatePicker
                  id="to-date"
                  selected={toDate}
                  onChange={(date) => setToDate(date)}
                  dateFormat="dd/MM/yyyy"
                  wrapperClassName="custom-datepicker-wrapper"
                  calendarClassName="custom-datepicker-calendar"
                />
              </div>
            </div>
          )}
          <div className="d-flex align-items-center">
            <ReactToPrint
              trigger={() => (
                <span
                  className="input-group-text"
                  id="pdf-icon"
                  style={{
                    backgroundColor: "#F6F6F6",
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                >
                  📑
                </span>
              )}
              content={() => componentRef.current}
            />{" "}
          </div>
        </div>
        <div ref={componentRef} style={{ backgroundColor: "white" }}>
          <div
            className="container col-md-8"
            style={{ textAlign: "center", color: "black" }}
          >
            <h5 style={{ fontWeight: "normal" }}>Code World</h5>
            <h4 style={{ fontWeight: "normal" }}>
              Profit and Loss (Schedule III)
            </h4>
            <p>Basis: Accrual</p>
            <p style={{ fontWeight: "normal" }}>
              FromTo {formatDate(fromDate)} - ToDate {formatDate(toDate)}
            </p>

            {/* First horizontal line */}
            <hr style={lineStyle} />

            {/* Section 1: Account and Total */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div>Particulars</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className="mr-4">Note No.</div>
                <div className="mr-4">Nov 2023</div>
                <div>Dec 2023</div>
              </div>
            </div>

            {/* Second horizontal line */}
            <hr style={lineStyle} />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div>I. Revenue from operations</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className="mr-4"></div>
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">II. Other Income</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
                blueTextStyle,
              }}
            >
              <div className="">III. Total Revenue (I + II)</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
                blueTextStyle,
              }}
            >
              <div className="">IV. Expenses</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4"> 1. Cost of materials consumed</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">2. Purchases of stock in trade</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">
                3. Changes in Inventories of finished goods work-in-progress and
                Stock-in-trade
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">4. Employee benefits expense</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">5. Finance Costs</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">
                6. Depreciation And Amortization Expense
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">7. Other Expenses</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">
                V. Profit before exceptional and extraordinary items and tax
                (III - IV)
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">VI. Exceptional Items </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">
                VII. Profit before extraordinary items and tax (V-VI)
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">VIII. Extraordinary Items</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">IX. Profit before tax (VII - VIII)</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">X. Tax Expense</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">1. Current tax</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="ml-4">2. Deferred tax</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">
                XI. Profit (Loss) for the period from continuing operations (IX
                - X)
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">
                XII. Profit (Loss) from discontinuing operations
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">
                XIII. Tax expense of discontinuing operations{" "}
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">
                XIV. Profit (Loss) from Discontinuing operations (after tax)
                (XII - XIII)
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0",
              }}
            >
              <div className="">
                XV. Profit (Loss) for the period (XI + XIV)
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <div className="mr-4">Note No.</div> */}
                <div className="mr-5">0.00</div>
                <div>0.00</div>
              </div>
            </div>
            <hr style={lineStyle} />

            {/* Section 2: Opening Income, Discount, Other Charges, Sales */}
          </div>
        </div>

        <div>
          <p
            style={{
              marginTop: "20px",
              display: "inline-block",
              marginLeft: "8px",
            }}
          >
            **Amount is displayed in your base currency{" "}
            <span
              style={{
                backgroundColor: "rgb(56,138,16)",
                padding: "2px 4px",
                fontWeight: "600",
                fontSize: "12px",
              }}
            >
              INR
            </span>
          </p>
        </div>
      </div>
    </>
  );
}

export default ProfitAndLossShedual3;
